import { Box, ToggleButton, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useColors from "../../api/hooks/useColors";
import useMSSP from "../../api/hooks/useMSSP";
import SvgToIcon from "../../icons/SvgToIcon";
import { icons } from "../../scenes/stack/environment/icons/iconExport";
import MSSPSelectTenantButton from "./MSSPSelectTenantButton";

const MSSPHeader = () => {
  const colors = useColors();
  const location = useLocation();
  const { isAllTenants, setIsAllTenants } = useMSSP();

  const [isDashboard, setIsDashboard] = useState(false);

  useEffect(() => {
    const isRoot = location.pathname === "/";
    setIsDashboard(isRoot);
  }, [location]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: "12px",
        ml: "20px",
        mt: "24px",
      }}
    >
      <Typography variant="overline" color={colors.text_primary}>
        View as
      </Typography>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          border: isDashboard ? "1px solid " + colors.grey_8percent : "none",
          borderRadius: "8px",
          padding: isDashboard ? "4px" : "0",
        }}
      >
        {isDashboard && (
          <ToggleButton
            value="tenant"
            selected={isAllTenants}
            onClick={() => {
              setIsAllTenants(true);
            }}
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "8px",
              borderRadius: "8px",
              border: "none",
              padding: "6px 8px",
              backgroundColor: colors.toggle_button_enabled_bg,
              "&:hover": {
                backgroundColor: colors.toggle_button_hovered_bg,
              },
              "&.Mui-selected": {
                backgroundColor: colors.toggle_button_selected_bg,
                color: colors.text_selected,
                "&:hover": {
                  backgroundColor: colors.toggle_button_selected_bg,
                },
                "&.Mui-focusVisible": {
                  backgroundColor: colors.toggle_button_focused_bg,
                },
              },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <SvgToIcon IconLogo={icons.MultiTenantIcon} width="20px" />

              <Typography variant="overline">All Tenants</Typography>
            </Box>
          </ToggleButton>
        )}
        <MSSPSelectTenantButton
          isAllTenants={isAllTenants}
          setIsAllTenants={setIsAllTenants}
        />
      </Box>
    </Box>
  );
};

export default MSSPHeader;
